import request from '@/util/request'

// 查菜单树
export function findMenuColTree() {
	return request({
		method: 'get',
		url: `/main/findMenuColTree`
	})
}
// 批量获取文章列表  colIds page limit
export function findArticleByColIds(data) {
	return request({
		method: 'post',
		url: `/main/findArticleByColIds`,
		data
	})
}

// 查询文章列表
export function findArticlePage(data) {
	return request({
		method: 'post',
		url: `/main/findArticlePage`,
		data
	})
}
// 查文章详情
export function findArticleOne(id) {
	return request({
		method: 'get',
		url: `/main/findArticleOne/${id}`
	})
}

export function findVideoOne(id) {
	return request({
		method: 'get',
		url: `/main/video/findOne/${id}`
	})
}
// 已读接口
export function updateArticleReadNum(id) {
	return request({
		method: 'get',
		url: `/main/updateArticleReadNum/${id}`
	})
}

// 查询视频列表
export function findVideoPage(data) {
	return request({
		url: `/main/video/findVideoPage`,
		method: 'post',
		data
	})
}
// ----

// 查article2 左侧列表
export function findMenuColListById(id) {
	return request({
		method: 'get',
		url: `/main/findMenuColListById/${id}`
	})
}


// 文章分页 轮播图
// let sendObj = {
// 				label: '',
// 				page: 1,
// 				limit: 20,
// 				status: '',
// 				type:id,
// 			}

// 获取节点详情
export function findMenuColById(id) {
	return request({
		method: 'get',
		url: `/main/findMenuColById/${id}`
	})
}
// 查询多个节点信息
export function findMenuColByIds(ids) {
	return request({
		method: 'get',
		url: `/main/findMenuColByIds/${ids}`
	})
}

// << 调查，留言
export function findQuestion() {
	return request({
		method: 'get',
		url: `/main/findQuestion`
	})
}
// 提交调查问卷
export function saveChooseUser(data) {
	return request({
		method: 'post',
		url: `/main/saveChooseUser`,
		data
	})
}
export function saveLeaveMsg(data) {
	return request({
		method: 'post',
		url: `/main/saveLeaveMsg`,
		data
	})
}
// >> 调查，留言

// *********** 底部 ***********
// 获取底部信息
export function findHomepageInfo() {
	return request({
		method: 'get',
		url: `/main/findHomepageInfo`
	})
}
// 评论、留言列表
export function findLeaveMsgPage(data) {
	return request({
		method: 'post',
		url: `/main/findLeaveMsgPage`,
		data
	})
}
// articleDesc 页

// -- << 物业企业承诺书申报
// 物业企业列表 page
// limit
// label
// type  类型  0非会员 1 会员
export function findCompanyPage(data) {
	return request({
		url: `/main/propertyCompany/findCompanyPage`,
		method: 'post',
		data
	})
}
// 申报
// @ApiModelProperty(value = "企业名称")
//     private String companyName;
//     @ApiModelProperty(value = "联系人姓名")
//     private String contactName;
//     @ApiModelProperty(value = "联系电话")
//     private String contactPhone;
//     @ApiModelProperty(value = "上传文件")
//     private String fileUrl;
//     @ApiModelProperty(value = "类型  0非会员 1 会员")
//     private String type;
//     @ApiModelProperty(value = "类型  0非会员 1 会员")
//     private String typeValue;
//     private int propertyCompanyId;//会员单位id
export function propertyCompanyShenbao(data) {
	return request({
		url: `/main/propertyCompany/shenbao`,
		method: 'post',
		data
	})
}
// 申报的分页
// page
// limit
// label
// type  类型  0非会员 1 会员
//  isAudit;0未审核 1 已审核 2 审核不通过
// (*注*   已签订公约企业 页面 isAudit==1        未签订公约企业曝光   isAudit==2 )
export function findShenbaoPage(data) {
	return request({
		url: `/main/propertyCompany/findShenbaoPage`,
		method: 'post',
		data
	})
}

// 物业企业承诺书申报附件查询
export function getOne() {
	return request({
		url: `/main/otherInfo/getOne`,
		method: 'get',
	})
}
// -- >> 物业企业承诺书申报



// WEBPACK FOOTER //
// ./src/api/index.js